
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import 'aos/dist/aos.css';
import '../styles/globals.css';
import '../styles/styles.scss';
import { Toaster } from 'react-hot-toast';
import { useEffect } from "react";
import { useRouter } from "next/router";
import { GTM_ID, pageView, PIXEL_ID } from "../lib/gtm";
import Script from "next/script";
import { WebSocketProvider } from "../context/WebSocketContext";
function App({ Component, pageProps }) {
    const router = useRouter();
    useEffect(() => {
        router.events.on('routeChangeComplete', pageView);
        return () => {
            router.events.off('routeChangeComplete', pageView);
        };
    }, [router.events]);
    useEffect(() => {
        const handleAgilePageView = () => {
            if (window._agile) {
                _agile.track_page_view();
            }
        };
        router.events.on('routeChangeComplete', handleAgilePageView);
        return () => {
            router.events.off('routeChangeComplete', handleAgilePageView);
        };
    }, [router.events]);
    return (<>
            <Script id="gtag-base" strategy="afterInteractive" dangerouslySetInnerHTML={{
            __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', '${GTM_ID}');
          `
        }}/>
            <Script id="meta-pixel" strategy="afterInteractive" dangerouslySetInnerHTML={{
            __html: `
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');

              fbq('init', ${PIXEL_ID});
              fbq('track', 'PageView');
            `
        }}/>
            <Script id="agile-init" strategy="beforeInteractive">
                {`
    window.Agile_API = window.Agile_API || {};
    window.Agile_API.on_after_load = function () {
      if (!window._agile) return;
      _agile.set_account('sq7rr3nithlvk420qciov47at2', 'hfdx', false);
      _agile.track_page_view();
      _agile_execute_web_rules();
      console.log('[Agile] initialized');
    };
  `}
            </Script>
            <Script id="_agile_min_js" src="https://d1gwclp1pmzk26.cloudfront.net/agile/agile-cloud.js" strategy="beforeInteractive"/>

            <WebSocketProvider>
                <Component {...pageProps}/>
            </WebSocketProvider>
            <Toaster />
        </>);
}

    export default __appWithI18n(App, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  